import React from "react"
import "./Animation.css"
import clouds from "../imgs/clouds.png"
import sky from "../imgs/sky.png"
import plane from "../imgs/plane.png"
import airfoil from "../imgs/airfoil.png"



const Animation=()=>{
					let degree=0;
					let counter =0;
					let x=100;
					function winginc(){
						degree=degree-1
						counter = counter+1;
						document.getElementById("airfoil").style.transform = "rotate("+degree+"deg)"
						document.getElementById("airfoil").style.transition = "0.15s"
						console.log(degree)
						document.getElementById("h1").innerHTML = "Angle Of Attack = "+counter+"&#xb0;"
						var lift = 0.615*1.5*25.99*degree*degree

						document.getElementById("lift").innerHTML = "Lift generated = "+lift
						var drag = 0.25*0.615*degree*degree
						document.getElementById("drag").innerHTML = "drag generated = "+drag

					if(degree<0){
						while(x>0){
							if(degree<0){
								document.getElementById("wing").style.top=(x)+"px";
								document.getElementById("wing").style.transition="15s";
								x--;
								
						}
						
						
						}
						
					}
						
					

					}
					function wingdec(){
						degree=degree+1
						counter = counter-1;
						document.getElementById("airfoil").style.transform = "rotate("+degree+"deg)"
						console.log(degree)
						document.getElementById("h1").innerHTML = "Angle Of Attack = "+counter+"&#xb0;"
						var lift = 0.615*1.5*25.99*degree*degree

						document.getElementById("lift").innerHTML = "Lift generated = "+lift
						var drag = 0.25*0.615*degree*degree
						document.getElementById("drag").innerHTML = "drag generated = "+drag

						if(degree>0){
						while(x<200){
							if(degree>0){
								document.getElementById("wing").style.top=(x+1)+"px";
						document.getElementById("wing").style.transition="15s";
						x++;
							}
							
						
						}
						
					}
					}
	return(
			<div>
			

				<button className="incdec" type="button" onClick={winginc}>+</button>
				<button className="incdec" type="button" onClick={wingdec}>-</button>
				<h1 id="h1">Angle Of Attack = 0&#xb0;</h1>
				<img src={sky} className="sky" alt="sky"/>
				<div id="bgimg">
					<img className="clouds" src={clouds} alt="clouds"/>
				</div>
				
				<div className="wing" id="wing">
				<img className="airplane" id="airplane" src={plane} alt="airplane"/>
				<img className="airfoil" id="airfoil" src={airfoil} alt="airfoil"/>
				
				</div>
				
				
				<div className="blankspace"></div>
				<h1 className="velocity">At constant velocity 200kmph and area of wing 25.99sqmeter</h1>
				<h1 className="lift" id="lift">Lift generated = 0</h1>
				<h1 className="thrust" id="drag">Drag generated = 0</h1>
			</div>
		);
}

export default Animation;